import { useEffect, useState } from "react";

const LONG_CREATION_DELAY_MS = 5_000;

export const useCreationTakingLonger = (busy: boolean): boolean => {
    const [takingLonger, setTakingLonger] = useState(false);

    useEffect(() => {
        if (!busy) {
            setTakingLonger(false);
            return;
        }

        const timer = window.setTimeout(() => setTakingLonger(true), LONG_CREATION_DELAY_MS);
        return () => window.clearTimeout(timer);
    }, [busy]);

    return takingLonger;
};
